import script from "./pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./pagination.vue?vue&type=script&setup=true&lang=ts"

import "./pagination.vue?vue&type=style&index=0&id=51cba813&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51cba813"]])

export default __exports__